import { Component, Output, EventEmitter } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-offer-popup',
  templateUrl: './offer-popup.component.html',
  styleUrls: ['./offer-popup.component.scss']
})
export class OfferPopupComponent {
  @Output() upgrade = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  constructor(public commonService: CommonService) {}

  onUpgrade(): void {
    this.upgrade.emit();
  }

  close(): void {
    this.commonService.closePopUp();
    this.closed.emit();
  }
}